import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient, { initializeApiClient } from "../../api/apiClient";
import { toast } from "react-toastify";

export default () => {
  const [data, setData] = useState({
    before: null,
    after: null,
    pdf: null,
  });
  const initialData = {
    measure_side: false,
    bleed_side: false,
    art_work: false,
    install_all_side: false,
    rolling_adz_decale: false,
    submit_photo_for_approval: false,
    upload_invoice: false,
    url: "",
  };
  const [submitData, setSubmitData] = useState(initialData);
  const handleChange = (key, value) => {
    setData({ ...data, [key]: value });
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const { request, loading, error } = useApi((formData) =>
    apiClient.post("/installerJob", formData)
  );
  useEffect(() => {
    const fetch = async () => {
      initializeApiClient();
      const response = await apiClient.get("/installerJob");
      const data = response.data;
      setSubmitData(data);
      setData(data?.photos);
    };
    fetch();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("before", data?.before);
    formData.append("after", data?.after);
    formData.append("pdf", data?.pdf);
    formData.append("measure_side", submitData?.measure_side);
    formData.append("bleed_side", submitData?.bleed_side);
    formData.append("art_work", submitData?.art_work);
    formData.append("install_all_side", submitData?.install_all_side);
    formData.append("rolling_adz_decale", submitData?.rolling_adz_decale);
    formData.append(
      "submit_photo_for_approval",
      submitData?.submit_photo_for_approval
    );
    formData.append("url", submitData?.url);
    const result = await request(formData);
    if (result.status === 200) {
      toast.success("Account Succesfully Created");
    } else {
      toast.error("Error");
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="">
            <div className="site-content-body">
              <div className="container-fluid main_bg_color">
                <div className="row">
                  <div className="col-lg-8 px-lg-2">
                    <div>
                      {/* Carousel */}
                      <div
                        id="demo"
                        className="carousel slide"
                        data-ride="carousel"
                      >
                        {/* The slideshow/carousel */}
                        <div className="carousel-inner test-2">
                          <div className="carousel-item active">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className=" col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={require("../../assets/img/jobs_JustDoIt_img.png")}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div
                                  className=" slider_line_height"
                                  style={{ color: "grey" }}
                                >
                                  <div className="d-flex message_dot_Posetion">
                                    <h4 className="bottom_line mb-3 mt-2">
                                      Driver & Vehicle Info
                                    </h4>
                                    <div className="posetion">
                                      {/* <i className="bi bi-chat-left-fill fa-2x my-auto message_color" /> */}
                                      {/* <i className="bi bi-dot fa-3x dot_posetion" /> */}
                                    </div>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Name:</span>
                                    <span> Ralf Sims</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Email:</span>
                                    <span>ralfsims@gmail.com</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Phone Number:
                                    </span>
                                    <span> 123-904-3245</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Model/Make:</span>
                                    <span>Hino 155</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Year:</span>
                                    <span>2012</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      License Plate:
                                    </span>
                                    <span> GLE623</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={require("../../assets/img/jobs_JustDoIt_img.png")}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <h4 className="bottom_line mb-3 mt-2">
                                    Driver & Vehicle Info.
                                  </h4>
                                  <p>
                                    <span className="fw-bold">Name:</span>
                                    <span> Ralf Sims</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Email:</span>
                                    <span>ralfsims@gmail.com</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Phone Number:
                                    </span>
                                    <span> 123-904-3245</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Model/Make:</span>
                                    <span>Hino 155</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Year:</span>
                                    <span>2012</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      License Plate:
                                    </span>
                                    <span> GLE623</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={require("../../assets/img/jobs_JustDoIt_img.png")}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <h4 className="bottom_line mb-3 mt-2">
                                    Driver & Vehicle Info.
                                  </h4>
                                  <p>
                                    <span className="fw-bold">Name:</span>
                                    <span> Ralf Sims</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Email:</span>
                                    <span>ralfsims@gmail.com</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Phone Number:
                                    </span>
                                    <span> 123-904-3245</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Model/Make:</span>
                                    <span>Hino 155</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">Year:</span>
                                    <span>2012</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      License Plate:
                                    </span>
                                    <span> GLE623</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          className="carousel-control-next carousel_errow"
                          type="button"
                          data-bs-target="#demo"
                          data-bs-slide="next"
                        >
                          <i className="bi bi-chevron-right fa-3x right_errow" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 px-lg-2 mt-lg-0 ">
                    <div
                      className="bg_more_deatils pt-2  px-3"
                      style={{ color: "grey" }}
                    >
                      <span className="">
                        <h4 className="bottom_line">Job Details</h4>
                      </span>
                      <p>
                        <span className="fw-bold">Install Location:</span>
                        <span> 321 James Rd., Los Angeles</span>
                      </p>
                      <p>
                        <span className="fw-bold">Install Date:</span>
                        <span>12/14/2022</span>
                      </p>
                      <p>
                        <span className="fw-bold">Install Time:</span>
                        <span>2:00 pm - 5:00 pm</span>
                      </p>
                      <p>
                        <span className="fw-bold">Packge Tracking Number:</span>
                        <span className=""> 12345678</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-lg-5 col-md-6 px-md-2 my-2">
                    <div className="test-2 py-2">
                      <span className="bottom_line ms-3 mt-1 mb-3">
                        <h5 className>Installer Checklist</h5>
                      </span>
                      <div className="px-3">
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.measure_side}
                            type="checkbox"
                            id="measure_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("measure_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="measure_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Measure side of Vehicle (height and width)
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.bleed_side}
                            type="checkbox"
                            id="bleed_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("bleed_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="bleed_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            (312 - "truck width")/2 = bleed on sides
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.art_work}
                            type="checkbox"
                            id="art_work"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("art_work", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="art_work"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            center artwork on Vehicle
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.install_all_side}
                            type="checkbox"
                            id="install_all_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("install_all_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="install_all_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Install all 4 sides
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.rolling_adz_decale}
                            type="checkbox"
                            id="rolling_adz_decale"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange(
                                "rolling_adz_decale",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            htmlFor="rolling_adz_decale"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Install "Rolling Ads" decals (refer to guide sheet)
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.submit_photo_for_approval}
                            type="checkbox"
                            id="submit_photo_for_approval"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange(
                                "submit_photo_for_approval",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            htmlFor="submit_photo_for_approval"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Take and submit photo for approval
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={submitData?.upload_invoice}
                            type="checkbox"
                            id="upload_invoice"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("upload_invoice", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="upload_invoice"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Upload invoice or invoice URL
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <div className="row">
                      <div className="col-12 p-2">
                        <div className="test-2 bg-white">
                          <span className="bottom_line ms-3">
                            <h5 className>Photo Uploads</h5>
                          </span>
                          <form action>
                            <div className="p-3 text-center">
                              <div className="d-flex mb-4">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-image" />
                                  <br />
                                  <label htmlFor="before" className="mt-1">
                                    Upload File Here (min. 4)
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    name
                                    id="before"
                                    onChange={(e) =>
                                      handleChange("before", e.target.files[0])
                                    }
                                  />
                                </div>
                                {data?.before ? (
                                  <img
                                    className="img-fluid w-25"
                                    src={data?.before}
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                                <div className="my-auto w-50">
                                  <h5>Before Photos</h5>
                                </div>
                              </div>
                              <div className="d-flex">
                                <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                  <i className="bi bi-file-earmark-image" />
                                  <br />
                                  <label htmlFor="after" className="mt-1">
                                    Upload File Here (min. 4)
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    hidden
                                    name
                                    id="after"
                                    onChange={(e) =>
                                      handleChange("after", e.target.files[0])
                                    }
                                  />
                                </div>
                                {data?.after ? (
                                  <img
                                    className="img-fluid w-25"
                                    src={data?.after}
                                    alt=""
                                  />
                                ) : (
                                  ""
                                )}
                                <div className="my-auto w-50">
                                  <h5>After Photos</h5>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className=" col-sm-6 p-2">
                        <div className="test-2 bg-white ">
                          <span className=" mb-0 bottom_line ms-3">
                            <h5 className>Invoice</h5>
                          </span>
                          <div className="p-3 text-center">
                            <div className=" text-center mx-lg-4 py-1 img_input_color">
                              <i className="bi bi-file-earmark-fill" />

                              <label className="mb-0" htmlFor="pdf py-4">
                                Upload Here
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                hidden
                                name
                                id="pdf"
                                onChange={(e) =>
                                  handleChange("pdf", e.target.files[0])
                                }
                              />
                            </div>
                            <img
                              className="img-fluid w-25"
                              src={data?.pdf}
                              alt=""
                            />
                            <p className="mb-0 py-1">OR</p>
                            <div className="mx-lg-4">
                              <input
                                type="url"
                                name
                                value={submitData?.url}
                                className="form-control img_input_color"
                                placeholder="Input invoice URL here..."
                                onChange={(e) =>
                                  handleChange("url", e.target.value)
                                }
                              />
                            </div>
                            <div className="text-center mt-1">
                              <button className="btn btn_bg  rounded-pill">
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 p-2">
                        <div className="test-2 bg-white ">
                          <span className="bottom_line ms-3">
                            <h5 className>Proof Sheet</h5>
                          </span>
                          <div className="p-3 text-center">
                            <div className="p-3 text-center">
                              <div className="text-center mx-lg-4 ">
                                <button className="btn px-2 py-2 img_input_color w-100 white_space">
                                  Proof Sheet
                                </button>
                              </div>
                            </div>

                            <div className="p-3 text-center">
                              <div className="text-center mx-lg-4 ">
                                <button className="btn px-2 py-2 img_input_color white_space w-100">
                                  Guide Sheet
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <button className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0">
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>
                  <a href="#" className="text-danger text-decoration-underline">
                    <p>Report problem with job</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
